export enum ETipoRegraPreco {
    Geral = 1,
    Regiao = 2,
    Estado = 3,
}
